import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';
import { ModalService } from '@sm360/widget-commons-general';

import ResetPasswordForm from 'login/components/ResetPassword/ResetPasswordForm/ResetPasswordForm.jsx';
import ModalHeader from 'login/components/Library/ModalHeader/ModalHeader.jsx';

import { RESET_PASSWORD as MODAL, LOGIN } from 'login/constants/modalNames.js';

const modal = ModalService.get(MODAL);

const czGroupName = 'widget.login.forms.resetpassword';

class ResetPasswordContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showForm: true,
        };

        this.showForm = this.showForm.bind(this);
        this.openLoginModal = this.openLoginModal.bind(this);

        this.headerTitleCz =
            ContentZonesService.getContentZone(czGroupName, 'maintext') &&
            ContentZonesService.getContentZone(czGroupName, 'maintext').getText();
        this.headerTextCz =
            ContentZonesService.getContentZone(czGroupName, 'subtext') &&
            ContentZonesService.getContentZone(czGroupName, 'subtext').getText();
    }

    showForm(value) {
        this.setState({
            showForm: value,
        });
    }

    openLoginModal() {
        ModalService.get(LOGIN).open();
        modal.close();
    }

    renderSuccessScreen() {
        return (
            <div>
                <div className="check" />
                <p className="reset-success-message">{LocaleService.t('LOGIN.RESET_PASSWORD.SUCCESS')}</p>
                <p className="log-back">
                    {LocaleService.t('LOGIN.RESET_PASSWORD.SIGN_IN')}
                    <button onClick={this.openLoginModal} className="sr-link">
                        {LocaleService.t('LOGIN.CLICK_HERE')}
                    </button>
                </p>
            </div>
        );
    }

    render() {
        return (
            <div className={`modal-login-content ${this.props.className}`}>
                <div id="reset-password" className="ResetPasswordForm">
                    <ModalHeader
                        titleContentZone={this.headerTitleCz}
                        textContentZone={this.headerTextCz}
                        showImage
                        showText={this.state.showForm}
                    />

                    {this.state.showForm ? (
                        <ResetPasswordForm showComponent={this.showForm} />
                    ) : (
                        this.renderSuccessScreen()
                    )}
                </div>
            </div>
        );
    }
}
ResetPasswordContent.defaultProps = {
    className: '',
};

ResetPasswordContent.propTypes = {
    className: PropTypes.string,
};

ResetPasswordContent.displayName = 'ResetPasswordContent';

export default ResetPasswordContent;
